import React, { useEffect, useState } from "react";
import OfflineOrderListing, { orderTone, StatusTab } from "./OfflineOrderListing";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setIsOpenEditDialog,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/OfflineOrderSlice";
import { useGetAllOfflineOrderDataQuery } from "src/services/OfflineOrderService";
import CancelOrderFormWrapper from "../Cancel/CancelAdvancePaymentWrapper";
import { usePermission } from "src/hooks/usePermission";

type Props = {};

const OfflineOrderListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const {
    items,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    isOpenEditDialog,
    isTableLoading,
    dateFilter,
  } = useSelector((state: RootState) => state.offlineOrder);
  const [selectedOrderId, setSelectedOrderId] = useState<string>();
  const [statusTab, setStatusTab] = useState<StatusTab>("SUCCESS");
  const statusOnServer = statusTab === "ALL" || statusTab === "CANCELLED";
  const { data, isLoading, isFetching } = useGetAllOfflineOrderDataQuery({
    limit: statusOnServer ? rowsPerPage : 10000,
    searchValue: searchValue,
    params: ["name", "email", "mobile", "orderId"],
    page: statusOnServer ? page : 1,
    filterBy:
      statusTab === "CANCELLED"
        ? [{ fieldName: "orderUiStatus", value: ["CANCELLED"] }]
        : [],
    dateFilter: dateFilter,
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: statusOnServer,
  });

  // Setting Module Data
  useEffect(() => {
    if (isLoading || isFetching) {
      dispatch(setIsTableLoading(true));
    } else {
      dispatch(setItems(data?.data || []));
      dispatch(setIsTableLoading(false));
      dispatch(setTotalItems(data?.totalItem || 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isFetching]);
const moduleName = "ORDER";

const canEdit = usePermission(moduleName, "UPDATE");

  const tabTone = {
    SUCCESS: "success",
    PENDING: "pending",
    FAILED: "failed",
    CANCELLED: "cancel",
  } as const;

  const filteredItems =
    statusTab === "ALL" || statusTab === "CANCELLED"
      ? items
      : items.filter((row) => orderTone(row) === tabTone[statusTab]);
  const visibleRows = statusOnServer
    ? filteredItems
    : filteredItems.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  const visibleTotal = statusOnServer ? totalItems : filteredItems.length;

  return (
    <div>
      <OfflineOrderListing
        rows={visibleRows}
        statusTab={statusTab}
        onStatusTabChange={(tab) => {
          setStatusTab(tab);
          dispatch(setPage(1));
        }}
        onCancel={(row) => {
          dispatch(setIsOpenEditDialog(true));
          setSelectedOrderId(row?._id);
        }}
        canEdit={canEdit}
        paginationProps={{
          isTableLoading,
          totalItems: visibleTotal,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
      {isOpenEditDialog ? (
        <CancelOrderFormWrapper
          onClose={() => dispatch(setIsOpenEditDialog(false))}
          selectedOrderId={selectedOrderId || ""}
        />
      ) : null}
    </div>
  );
};

export default OfflineOrderListingWrapper;
